<div class="main">
  <div class="main-content" *ngIf="!confirmationFlag">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-12 p-jc-center content-detail">
        <div class="steps p-field p-col-12">
          <app-a200-steps
            [class_id]="a201ApplicationInputForm.get('class_id').value"
          ></app-a200-steps>
        </div>

        <div class="p-grid form p-jc-center">
          <div
            class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center"
          >
            <div class="form-content p-col-8 p-md-12 p-sm-12">
              <form [formGroup]="a201ApplicationInputForm" autocomplete="off">
                <div class="form-container">
                  <div class="p-grid">
                    <div class="p-col-3 p-xl-2">
                      <label for="zip-code" class="zip-code-label"
                        >団体区分</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div
                      class="p-col-7 role-row p-xl-9"
                    >
                      <p-radioButton
                        value="1"
                        label="中学校・高校等（中高生）"
                        formControlName="class_id"
                        class="school-teacher-role"
                        (ngModelChange)="resetForm()"
                      ></p-radioButton>

                      <p-radioButton
                        value="2"
                        label="保育所・幼稚園等（乳幼児）"
                        formControlName="class_id"
                        class="provider-role"
                        (ngModelChange)="resetForm()"
                      ></p-radioButton>
                    </div>
                    <div class="p-col-7 p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('class_id')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="address" class="address-label"
                        >団体区分詳細</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <!-- chưa sửa tên -->
                    <div class="p-col-5 p-xl-3">
                      <p-dropdown
                        inputId="city"
                        optionLabel="name"
                        optionValue="value"
                        class="select-city"
                        formControlName="class_sub_id" 
                        [options]="filterOrganizationList"
                        placeholder="　"
                        [showClear]="false"
                      ></p-dropdown>
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('class_sub_id')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="school" class="school-label"
                        >団体名</label
                      >

                    </div>
                    <div class="p-col-2 p-xl-1 required-end">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-7  p-xl-9">
                      <input
                        title="団体名"
                        id="school"
                        class="input-school"
                        type="text"
                        pInputText
                        formControlName="organization_name"
                        placeholder=""
                        autocomplete="off"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"organization_name")?"invalid-length":""'
                      />
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="
                          a201ApplicationInputForm.get('organization_name')
                        "
                      >
                      </app-validator-message>
                    </div>
                  </div>
                   <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="address" class="address-label"
                        >設置者区分</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-5 p-xl-3">
                      <p-dropdown
                        inputId="city"
                        optionLabel="name"
                        optionValue="value"
                        class="select-city"
                        formControlName="installer_id" 
                        [options]="establisherTypeList"
                        placeholder="国"
                        [showClear]="false"
                      ></p-dropdown>
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('installer_id')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="zip-code" class="zip-code-label"
                        >郵便番号</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-7 p-xl-9">
                      <input
                        title="郵便番号"
                        id="zip-code"
                        class="input-zip-code-after"
                        type="text"
                        pInputText
                        formControlName="postal_no"
                        placeholder="8128577"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"postal_no")?"invalid-length":""'
                        autocomplete="off"
                      />
                    </div>

                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('postal_no')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="address" class="address-label"
                        >所在地(市区町村)</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>

                    <div class="p-col-5 p-xl-3">
                      <p-dropdown
                        inputId="city"
                        optionLabel="name"
                        optionValue="value"
                        class="select-city"
                        formControlName="municipalities"
                        [options]="postalNoList"
                        placeholder="○○市"
                        [showClear]="false"
                        [filter]="true"
                      ></p-dropdown>
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('municipalities')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="city" class="long-label"> 所在地(それ以降の住所)</label>
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-7  p-xl-9">
                      <input
                        title="所在地(それ以降の住所)"
                        id="address"
                        class="input-address"
                        type="text"
                        pInputText
                        formControlName="address_building"
                        placeholder="東公園７番７号"
                        autocomplete="off"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"address_building")?"invalid-length":""'
                      />
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="
                          a201ApplicationInputForm.get('address_building')
                        "
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="phone-number" class="phone-number-label"
                        >電話番号</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>

                    <div class="p-col-7 p-xl-9">
                      <input
                        title="電話番号"
                        id="phone-number"
                        class="input-phone-number-right"
                        type="text"
                        pInputText
                        formControlName="tel"
                        placeholder="0926433013"
                        autocomplete="off"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"tel")?"invalid-length":""'
                      />
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('tel')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-col-3 p-xl-2 message-field">
                    <label class="message-label">※本システム利用者に開示されますので、携帯電話など、個人の番号は登録しないで下さい。</label>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="mail-address" class="mail-address-label"
                        >メールアドレス</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-7  p-xl-9">
                      <input 
                        title="メールアドレス"                                 
                        id="mail-address"
                        class="input-mail-address"
                        type="text"
                        pInputText
                        formControlName="email"
                        placeholder=""
                        autocomplete="off"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"email")?"invalid-length":""'
                      />
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('email')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-col-3 p-xl-2 message-field">
                    <label class="message-label">※ご登録いただいたメールアドレスに、マッチング依頼の受信通知等の重要なお知らせが届きます。</label>
                  </div>

                  <div class="p-grid">
                    <div class="p-col-3  p-xl-2">
                      <label for="mail-address" class="mail-address-label"
                        >担当者氏名</label
                      >
                    </div>
                    <div class="p-col-2 required-end p-xl-1">
                      <span class="required">*必須</span>
                    </div>
                    <div class="p-col-7  p-xl-9">
                      <input
                        title="メールアドレス"
                        id="mail-address"
                        class="input-mail-address"
                        type="text"
                        pInputText
                        formControlName="full_name"
                        placeholder=""
                        autocomplete="off"
                        [ngClass]='checkInputMaxBoundary(a201ApplicationInputForm,"full_name")?"invalid-length":""'
                      />
                    </div>
                    <div class="p-col-7  p-xl-9 error-message">
                      <app-validator-message
                        [control]="a201ApplicationInputForm.get('full_name')"
                      >
                      </app-validator-message>
                    </div>
                  </div>

                  <div class="p-grid">
                    <label class="custom-checkbox">
                        <input title="担当者氏名" type="checkbox" formControlName="systemusage_agreement" class="checkbox">
                        <span class="checkmark"></span>
                        システム利用にあたり、以下の注意事項に同意します。<br>
                      </label>
                  </div>
                  <div class="agree-message">
                    <span>・本システムは、ふれあい体験の実施を希望する団体同士をつなぐプラットフォームとして運営しております。マッチング後の体験活動は、体験を実施される各団体で、事故防止等、責任をもって実施・運営してください。<br></span>
                    <span>・ふれあい体験の実施にあたり、個人情報を団体間で共有される場合などは、利用者ご自身で厳正に取り扱っていただくようお願いします。</span>
                  </div>
                </div>
              </form>
            </div>


            <div class="form-content register p-col-8">
              <div class="p-grid p-grid-register">
                <div class="p-col-6 btn-block p-md-3 p-xl-4">
                  <button
                    pButton
                    type="button"
                    label="確認画面へ"
                    class="btn-register"
                    (click)="moveA202()"
                    [disabled]="
                       !a201ApplicationInputForm.valid
                    "
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-content" *ngIf="confirmationFlag">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-12 p-jc-center content-detail">
        <div class="steps p-field p-col-12">
          <app-a200-steps
            [class_id]="a201ApplicationInputForm.get('class_id').value"
          ></app-a200-steps>
        </div>

        <div class="p-grid form p-jc-center">
          <div
            class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center"
          >
            <div class="form-content p-col-8 p-md-12 p-sm-12">
              <div class="form-cofirm-container">
                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="school" class="school-label"
                      >団体区分</label
                    >
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div
                    class="p-col-7  text-center p-d-flex p-xl-9 class-input"
                  >
                    <div class="star-rate">
                      <div class="role-container">
                        <span
                          class="circle-role"
                          *ngIf="
                            this.a201ApplicationInputForm.controls.class_id.value ==  '1'
                          "
                        ></span>
                      </div>
                      <span class="star-rate-number"
                        >中学校・高校等（中高生）</span
                      >
                    </div>
                    <div class="star-rate role-after">
                      <div class="role-container">
                        <span
                        class="circle-role"
                        *ngIf="
                          this.a201ApplicationInputForm.controls.class_id.value == '2'
                        "
                      ></span>
                      </div>
                      <span class="star-rate-number"
                        >保育所・幼稚園等（乳幼児）</span
                      >
                    </div>
                  </div>
                </div>
                
                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="school" class="school-label">団体区分詳細</label>
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ getNameByValue(this.filterOrganizationList, a201ApplicationInputForm.value?.class_sub_id)}}
                  </div>
                </div>


                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="school" class="school-label">団体名</label>
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ a201ApplicationInputForm.value?.organization_name }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="school" class="school-label">設置者区分</label>
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ getNameByValue(this.establisherTypeList, a201ApplicationInputForm.value?.installer_id) }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="zip-code" class="zip-code-label"
                      >郵便番号</label
                    >
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-5 text-center p-xl-3">
                    {{ a201ApplicationInputForm.value?.postal_no }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="address" class="address-label">所在地(市区町村)</label>
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>

                  <div class="p-col-5 text-center p-xl-3">
                    {{ getNameByValue(this.postalNoList, a201ApplicationInputForm.value?.municipalities) }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="city" class="long-label"> 所在地(それ以降の住所)</label>
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ a201ApplicationInputForm.value?.address_building }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="phone-number" class="phone-number-label"
                      >電話番号</label
                    >
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>

                  <div class="p-col-7 text-center p-xl-4">
                    {{ a201ApplicationInputForm.value?.tel }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="mail-address" class="mail-address-label"
                      >メールアドレス</label
                    >
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ a201ApplicationInputForm.value?.email }}
                  </div>
                </div>

                <div class="p-grid">
                  <div class="p-col-3  p-xl-2">
                    <label for="mail-address" class="mail-address-label"
                      >担当者氏名</label
                    >
                  </div>
                  <div class="p-col-2 required-end p-xl-1">
                    <span class="required">*必須</span>
                  </div>
                  <div class="p-col-7  text-center p-xl-9">
                    {{ a201ApplicationInputForm.value?.full_name }}
                  </div>
                </div>

                <div class="p-grid">
                    <label class="custom-checkbox-confirm">
                        <span class="checkmark"></span>
                        システム利用にあたり、以下の注意事項に、同意します。<br>
                      </label>
                  </div>
                  <div class="agree-message-confirm">
                    <span>・本システムは、ふれあい体験の実施を希望する団体同士をつなぐプラットフォームとして運営しております。マッチング後の体験活動は、体験を実施される各団体で、事故防止等、責任をもって実施・運営してください。<br></span>
                    <span>・ふれあい体験の実施にあたり、個人情報を団体間で共有される場合などは、利用者ご自身で厳正に取り扱っていただくようお願いします。</span>
                  </div>

                <div
          class="form-content register p-col-12"
        >
          <div class="p-grid p-grid-register center">
            <div class="p-col-5 btn-block p-md-3 p-xl-4">
              <button
                pButton
                type="button"
                label="登録する"
                class="btn-register"
                (click)="moveA203()"
              ></button>
            </div>
            <div class="p-col-5 btn-block p-md-3 p-xl-4">
              <button
              pButton
              type="button"
              label="入力画面へ戻る"
              class="button2 btn-register"
              (click)="moveA201()"
            ></button>
            </div>
          </div>
        </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
